import clsx from "clsx"
import PropTypes from "prop-types"
import { useEffect, useState } from "react"
import { useFormContext } from "react-hook-form"
import SharedDialog from "~/dialogs/SharedDialog"
import NewSearchInput from "../../Common/NewSearchInput"

const AddResourceDialog = ({ open, closeDialog, data, type }) => {
  const { setValue, watch } = useFormContext()
  const resource = watch(`${type}s`)

  const [selectedData, setSelectedData] = useState(resource)
  const [filteredData, setFilteredData] = useState(data)

  useEffect(() => {
    setSelectedData(resource)
  }, [resource])

  const handleSelect = (resource) => {
    if (selectedData.find((c) => c.id === resource.id)) {
      setSelectedData(selectedData.filter((c) => c.id !== resource.id))
    } else {
      setSelectedData([...selectedData, resource])
    }
  }

  const handleSearch = (value) => {
    const filtered = data.filter((resource) =>
      resource.name.toLowerCase().includes(value.toLowerCase()),
    )
    setFilteredData(filtered)
  }

  return (
    <SharedDialog
      isOpen={open}
      onClose={() => {
        setSelectedData(resource)
        closeDialog()
      }}
      action={() => {
        setValue(`${type}s`, selectedData, { shouldDirty: true })
        closeDialog()
      }}
    >
      <div>
        <div className="flex justify-between items-center mb-10">
          <h2 className="capitalize">Add {type}s</h2>
          <NewSearchInput
            handleSearch={handleSearch}
            className="border"
            type={type}
          />
        </div>
        {filteredData?.map((resource) => {
          const selected = selectedData?.find((c) => c.id === resource.id)
          const imageKey = [type === "path" ? "badge_image" : "thumbnail"]
          return (
            <div
              key={resource.id}
              className={clsx(
                "border flex flex-col md:flex-row my-2 gap-2 rounded-lg md:h-20 items-center md:items-stretch px-1 md:px-0 py-2 md:py-0",
                {
                  "border-primary": selected,
                  "border-gray3": !selected,
                },
              )}
            >
              <div className="w-[20%] ">
                {resource[imageKey]?.secure_url && (
                  <img
                    src={resource[imageKey]?.secure_url ?? ""}
                    alt=""
                    className="rounded-tl-lg rounded-bl-lg hidden md:block h-full"
                  />
                )}
              </div>
              <div className="w-[60%] flex justify-center flex-col items-center md:items-start">
                <h3 className="text-sm md:text-lg">{resource.name}</h3>
                {resource.version && <p>Version: {resource.version}</p>}
              </div>
              <div className="flex items-center justify-center w-[20%]">
                <button
                  className="flex justify-center items-center bg-[#09295829] hover:bg-gray4 p-2 rounded-md h-10 md:mr-3 w-28"
                  onClick={() => {
                    handleSelect(resource)
                  }}
                >
                  {!selected ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="#092958"
                      className="w-6 h-6 mr-2"
                      fill="none"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="#092958"
                      className="w-6 h-6 mr-2"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15 12H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                      />
                    </svg>
                  )}
                  <p className="uppercase text-sm font-medium">
                    {selected ? "Remove" : "Add"}
                  </p>
                </button>
              </div>
            </div>
          )
        })}
      </div>
    </SharedDialog>
  )
}

AddResourceDialog.propTypes = {
  open: PropTypes.bool,
  closeDialog: PropTypes.func,
  initialValues: PropTypes.array,
  setValue: PropTypes.func,
}

export default AddResourceDialog
